module.exports = __webpack_public_path__ + "img/ontology-search-illustration.1da0f75b.png";